import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useCalendarStore } from 'components/mrp/stores/calendarStore/calendarStore';
import { CalendarViewState } from 'components/mrp/stores/calendarStore/calendarStore.types';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

const CALENDAR_VIEWSTATE_OPTIONS = ['APPOINTMENT', 'AVAILABILITY'];

const CalendarViewStateToggle = ({
  onAnyAction
}: {
  onAnyAction: () => void;
}) => {
  const { t } = useTranslation('common', { keyPrefix: 'mrp' });

  const { viewState, setViewState } = useCalendarStore(
    useShallow((state) => ({
      viewState: state.viewState,
      setViewState: state.control.setViewState
    }))
  );

  const handleViewStateChange = (
    _event: React.MouseEvent<HTMLElement>,
    newState: CalendarViewState
  ) => {
    newState && setViewState(newState);
    onAnyAction();
  };

  return (
    <ToggleButtonGroup
      aria-label="calendar view-state"
      exclusive
      fullWidth
      onChange={handleViewStateChange}
      orientation="horizontal"
      size="small"
      value={viewState}
    >
      {CALENDAR_VIEWSTATE_OPTIONS.map((option) => (
        <ToggleButton key={option} value={option}>
          {t(`viewStateTypes.${option}`)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default CalendarViewStateToggle;
